module.exports = __webpack_public_path__ + "img/brillante_8.f233b825.svg";